import React from "react";
import PropTypes from 'prop-types';
import { NativeBaseProvider, } from "native-base"
import { useCachedResources } from "~/native-ui/hooks/useCachedResources"
import {  DrawerAnimationContextProvider } from "~/native-ui/Navigation/DrawerAnimationContext";

import { getTheme } from "./theme";


export const ThemeProvider = (props) =>  {
    const { themeColor, children } = props;
    const isLoaded = useCachedResources();

    const config = React.useMemo(() => ({ theme: getTheme(themeColor), suppressColorAccessibilityWarning: true }), [ themeColor ]);

    if (!isLoaded) {
        return null;
    }

    return (
        <NativeBaseProvider config={config}>
            <DrawerAnimationContextProvider>
                { children }
            </DrawerAnimationContextProvider>
        </NativeBaseProvider>
    )
}


ThemeProvider.propTypes = {
    themeColor: PropTypes.string
}